import React from 'react';

import {Route, Switch, useRouteMatch} from "react-router-dom";
import ListPage from "./ListPage";
import AddEditPage from "./AddEditPage";


export const ContractsPage = () => {
    const {path} = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}>
                <ListPage/>
            </Route>
            <Route path={`${path}/add`}>
                <AddEditPage/>
            </Route>
            <Route path={`${path}/:id`}>
                <AddEditPage/>
            </Route>
        </Switch>
    )
}